<script lang="ts" setup>
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline';
import { ref } from 'vue';
import { echo } from '../echo';
import { Alert } from '@vue-interface/alert';

const newVersion = ref<string>();

echo.channel('manifest')
    .listen('NewVersionAvailable', ({ version }: {version: string}) => {
        newVersion.value = version;
    });

function onClickRefresh() {
    window.location.reload();
}
</script>

<template>
    <Alert
        v-if="newVersion"
        class="alert-emerald-500 rounded-none justify-center">
        <template #icon>
            <ExclamationTriangleIcon />
        </template>
        A new version ({{ newVersion }}) of Alchemy is available.
        <button
            class="btn btn-xs btn-white"
            @click="onClickRefresh">
            Reload
        </button>
    </Alert>
</template>